import { Big } from 'big.js';
import { TenantJobLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import MpiJob from '~/tenants/mpi/model/MpiJob';
import MpiCustomConfig from '~/tenants/mpi/performable/custom/MpiCustomConfig';

export default class MpiCustomJob extends MpiJob<typeof MpiCustomConfig> {
  get performable(): typeof MpiCustomConfig {
    return MpiCustomConfig;
  }

  get configurable(): boolean {
    return true;
  }

  get hidden(): boolean {
    return true;
  }

  defaultValue(): ZodVersionedMetadata<(typeof MpiCustomConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      description: '',
      rate: 0,
    };
  }

  onsite(): number {
    const { onsite } = this.metadata;

    return onsite ?? 0;
  }

  revenueLines(): TenantJobLine[] {
    const { description, rate, taxable } = this.metadata;
    const lines: TenantJobLine[] = [];

    if (rate) {
      lines.push({
        id: 'custom_service',
        description,
        amount: new Big(rate),
        taxable,
      });
    }

    return lines;
  }

  expenseLines(): TenantJobLine[] {
    const { description, pay } = this.metadata;
    const lines: TenantJobLine[] = [];

    if (pay) {
      lines.push({
        id: 'custom_service',
        description,
        amount: new Big(pay),
      });
    }

    return lines;
  }
}
